import { Route, Routes } from "react-router-dom";

import { Contact } from "./Contact";
import { Cookie } from "./Cookie";
import { Footer } from "../../components/FooterEn";
import { History } from "./History";
import { Home } from "./Home";
import { NavigationBar } from "../../components/NavigationBarEn";
import { Privacy } from "./Privacy";
import React from "react";
import { Vineyards } from "./Vineyards";
import { Wine } from "./Wine";
import { Wines } from "./Wines";

export const RouteEn = () => {

  return (
    <React.Fragment>
      <NavigationBar />
      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/history" element={<History />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/vineyards" element={<Vineyards />} />
          <Route path="/vineyards/:nome" element={<Vineyards />} />
          <Route path="/wines" element={<Wines />} />
          <Route path="/wines/:nome" element={<Wines />} />
          <Route path="/:nome/:anno" element={<Wine />} />
          <Route path="/cookie" element={<Cookie />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
      <Footer />
    </React.Fragment>
  );
}
